import { useState, useCallback } from 'react';
import '../../utils/assertions.es.js';
import { warn } from '../../utils/functions.es.js';
import '../../utils/responsive.es.js';
import '../../utils/scrollIntoView.es.js';
import 'polished';
import '@styled-system/css';
import 'styled-components';
import '../../utils/useEnhancedEffect.es.js';
import 'react-is';

const useControlled = (props = {}) => {
  const { value: valueProp, defaultValue, onChange } = props;
  const isControlled = valueProp !== void 0;
  warn({
    condition: !isControlled && defaultValue === void 0,
    message: "useControlled: You need to add a default value when using an uncontrolled component"
  });
  const [valueState, setValue] = useState(defaultValue);
  const value = isControlled ? valueProp : valueState;
  const updateValue = useCallback((value2) => {
    if (!isControlled) {
      setValue(value2);
    }
    onChange == null ? void 0 : onChange(value2);
  }, [isControlled, onChange]);
  return [value, updateValue];
};

export { useControlled };
//# sourceMappingURL=useControlled.es.js.map
